import { render, staticRenderFns } from "./Cabys.vue?vue&type=template&id=24c6c8e3&scoped=true"
import script from "./Cabys.vue?vue&type=script&lang=js"
export * from "./Cabys.vue?vue&type=script&lang=js"
import style0 from "./Cabys.vue?vue&type=style&index=0&id=24c6c8e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c6c8e3",
  null
  
)

export default component.exports